import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'ng2-app/http/clients/api';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Report } from 'ng2-app/models/report/report.model';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PerformanceService {
  baseUrl = '/performance';

  constructor(
    private http: ApiHttpClient
  ) { }

  /**
   * Hit's the /reporting-performance endpoint to gather data based on whether a radio selection was made or the date
   * picker was used to define the date range.+
   *
   * @param startDate
   * @param endDate
   * @param radioSelection
   */
  getRepReports(useNewReport: boolean): Observable<any> {
    if(useNewReport) {
      const searchParams = new HttpParams()
        .set('reportName', 'sales');
      return this.http.get<Report[]>(`${environment.API_URL}/report/performance`, { params: searchParams });
    } else {
      const searchParams = new HttpParams()
        .set('report', 'incoming-leads')
        .set('type', 'aggregate') // must be aggregate, time is not supported
        .set('group', 'lenderUser')
        .set('interval', 'DAY')
        .set('range', 'today');
      return this.http.get<Report[]>(`${environment.API_URL}/reporting-performance`, { params: searchParams });
    }
  }
}

